import { useState, useEffect, useCallback, useRef } from 'react';
import { ActionButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input';
import { PotentialClientsTable } from '../../common/Tables/Tables';
import { potentialClientsTableHeader } from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { salesRoles } from '../../../assets/helpers/roles.js';
import { membershipService } from '../../../services/membershipService';
import { potentialClientsService } from '../../../services/potentialClientsService';
import { useHistory } from 'react-router-dom';
import { FilterDatePicker, SearchInput } from '../../common/Forms/Input/Input';
import moment from 'moment';
import { useDropzone } from 'react-dropzone';
import './PotentialClients.scss';
import authService from '../../../services/authService.js';
import { SendFileModal } from '../../common/Modals/Modals.jsx';
import { FilterButton } from '../Exportables/Exportables.jsx';
import { capitalize } from '@material-ui/core';

const itemsPerpage = [10, 25, 50, 100, 500];

export const PotentialClients = () => {
  const tableRef = useRef(null);
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const [showImageModal, setShowImageModal] = useState({
    isOpen: false,
    label: 'Archivo',
    tag: '',
    message: '(Excel. máx. 3MB)',
    extension: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    selected: '',
  });

  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [channels, setChannels] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [serviceTypesOptions, setServiceTypesOptions] = useState([]);
  const [campaignActionOptions, setCampaignActionOptions] = useState([]);
  const [affiliatedOptions, setAffiliatedOptions] = useState([]);

  const [converteRate, setConverteRate] = useState(null);
  const [totalOrders, setTotalOrders] = useState(null);

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
    type: 'Evento', // Particular, Evento, Free
  });

  const setFirstPage = () => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateTo(e);
    }
  };

  const selectType = (type) => {
    type =
      type === 'Eventos'
        ? 'Evento'
        : type === 'Particulares'
          ? 'Particular'
          : type === 'Plan free'
            ? 'Free'
            : type === 'PAP'
              ? 'Pap'
              : type === 'Incompletos'
                ? 'Incompleta'
                : type;
    if (type === membershipsDatatable?.type) {
      return null;
    }

    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        data: [],
        count: 0,
        type: type,
        // isLoading: true,
      };
    });
  };

  const matchTypeToLabel = (type) => {
    return type === 'Evento'
      ? 'Eventos'
      : type === 'Particular'
        ? 'Particulares'
        : type === 'Free'
          ? 'Plan free'
          : type === 'Pap'
            ? 'PAP'
            : type === 'Incompleta'
              ? 'Incompletos'
              : type;
  };

  const selectitemsPerpage = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const channelListOptions = (arr) => {
    let channels = [];
    arr?.sort((a, b) => {
      if (a?.channel < b?.channel) {
        return -1;
      }
      if (a?.channel > b?.channel) {
        return 1;
      }
      return 0;
    });

    if (arr) {
      for (let i = 0; i < arr?.length; i++) {
        channels.push({
          _id: arr[i]?._id,
          name: capitalize(arr[i]?.name),
        });
      }
    }
    return channels;
  };

  const serviceTypeListOptions = (arr = []) => {
    if (!Array.isArray(arr)) return [];

    return arr
      .filter(
        (item) =>
          item &&
          typeof item === 'object' &&
          (typeof item._id === 'string' || typeof item.name === 'string')
      )
      .map((item) => {
        const rawValue = item?.name || item?._id || '';
        return {
          _id: item?._id || rawValue,
          name: capitalize(String(rawValue).trim().toLowerCase()),
        };
      })
      .sort((a, b) =>
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
      );
  };

  const handleChannelOptions = (arr) => {
    setChannelOptions(arr);
  };
  const handleServiceTypeOptions = (arr) => {
    setServiceTypesOptions(arr);
  };

  const handleCampaignActionOptions = (arr) => {
    setCampaignActionOptions(arr);
  };

  const handleAffiliatedOptions = (arr) => {
    setAffiliatedOptions(arr);
  };

  const handlePageChange = (event, value) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * membershipsDatatable?.limit,
      };
    });
  };

  const handleSearchChange = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
        data: false,
      };
    });
  };

  const handleImageModal = () => {
    setShowImageModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showImageModal?.isOpen,
      };
    });
  };

  const redirectToEditOrder = (orderId) => {
    history.push(`/afiliations/edit-order/${orderId}`);
  };

  const redirectToOrderDetail = (order) => {
    history.push(
      `/afiliations/order-details/${order?._id}/vehicle/${order?.vehicleId}`
    );
  };

  const renewMembership = (membership) => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .reativateMembership(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            notify(`Membresia reactivada`, 'success');
            redirectToEditOrder(membership?._id);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const exportMemberships = () => {
    let body = {
      ...(membershipsDatatable?.type && { type: membershipsDatatable?.type }),
      ...(membershipsDatatable?.limit && {
        limit: membershipsDatatable?.limit,
      }),
      ...(membershipsDatatable?.offset && {
        offset: membershipsDatatable?.offset,
      }),
      ...(membershipsDatatable?.searchParam && {
        search: membershipsDatatable?.searchParam,
      }),
      ...(dateFrom ? { dateFrom: moment(dateFrom).format('YYYY-MM-DD') } : {}),
      ...(dateTo ? { dateTo: moment(dateTo).format('YYYY-MM-DD') } : {}),
      type: membershipsDatatable?.type,
      ...(channelOptions.length > 0 && { channels: channelOptions }),
      ...(serviceTypesOptions.length > 0 && { serviceType: serviceTypesOptions }),
      ...(campaignActionOptions.length > 0 && {
        campaignActions: campaignActionOptions,
      }),
      ...(affiliatedOptions.length === 1 && {
        isAffiliated: affiliatedOptions[0],
      }),
      byMail: true,
    };

    setIsLoading(true);

    potentialClientsService
      .getPotentialClients(body)
      .then((response) => {
        if (response.status === 200) {
          notify(
            `El archivo se está generando y será enviado a su correo`,
            'info'
          );
          setIsLoading(false);
        } else {
          setIsLoading(false);
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => {
        setIsLoading(false);
      });

    return true;
  };

  const validateCounterType = () => {
    let user = authService?.getUser()
    if (user?.roles[0]?.code === salesRoles?.SALES_COUNTER && user?.type === "Externo") {
      history.push('/dashboard/analytics')
    }
  }

  useEffect(() => {
    getMemberships();
    validateCounterType()
    // getMembershipsByStatus();
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.limit,
    membershipsDatatable?.type,
    dateFrom,
    dateTo,
    channelOptions,
    serviceTypesOptions,
    campaignActionOptions,
    affiliatedOptions,
  ]);

  const getMemberships = () => {
    let body = {
      ...(membershipsDatatable?.type && { type: membershipsDatatable?.type }),
      ...(membershipsDatatable?.limit && {
        limit: membershipsDatatable?.limit,
      }),
      ...(membershipsDatatable?.offset && {
        offset: membershipsDatatable?.offset,
      }),
      ...(membershipsDatatable?.searchParam && {
        search: membershipsDatatable?.searchParam,
      }),
      ...(dateFrom ? { dateFrom: moment(dateFrom).format('YYYY-MM-DD') } : {}),
      ...(dateTo ? { dateTo: moment(dateTo).format('YYYY-MM-DD') } : {}),
      type: membershipsDatatable?.type,
      ...(channelOptions.length > 0 && { channels: channelOptions }),
      ...(serviceTypesOptions.length > 0 && { serviceType: serviceTypesOptions }),
      ...(campaignActionOptions.length > 0 && {
        campaignActions: campaignActionOptions,
      }),
      ...(affiliatedOptions.length === 1 && {
        isAffiliated: affiliatedOptions[0],
      }),
    };

    setIsLoading(true);

    potentialClientsService
      .getPotentialClients(body)
      .then((response) => {
        if (response.status === 200) {
          console.log('response?.data?.convertRate', response?.data?.convertRate);
          setConverteRate(response?.data?.convertRate);
          setTotalOrders(response?.data?.total);

          // SIEMPRE cargar filterOptions cuando offset es 0 O cuando no hay opciones cargadas
          const shouldLoadFilterOptions =
            membershipsDatatable?.offset === 0 || channels.length === 0;

          if (shouldLoadFilterOptions) {
            const filterOptions = response.data?.filtersOptions || {};

            const formattedChannels = channelListOptions(
              filterOptions.channels || []
            );

            const formattedServiceTypes = serviceTypeListOptions(
              filterOptions.serviceTypes || []
            );
            setChannels(formattedChannels);
            setServiceTypes(formattedServiceTypes);

            setMembershipsDatatable((prevState) => {
              setIsLoading(false);
              return {
                ...prevState,
                data: response?.data?.data,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            setMembershipsDatatable((prevState) => {
              setIsLoading(false);
              return {
                ...prevState,
                data: response?.data?.data,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          }
        }
      })
      .catch(() => {
        setIsLoading(false);
      });

    return true;
  };

  const updateClientFromGrid = (data) => {
    const body = {};
    if (data?.campaignAction) {
      body.campaignAction = data?.campaignAction;
    }
    if (data?.situation) {
      body.situation = data?.situation;
    }

    if (body?.campaignAction || body?.situation) {
      potentialClientsService
        .updatePotentialClients(data?.id, body)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify('Actualización exitosa', 'info');
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {
          notify('Error al actualizar', 'error');
        });
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        // Do whatever you want with the file contents
      };
      reader.readAsArrayBuffer(file);

      if (![...showImageModal?.extension].includes(file.type)) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        setFileUploaded(file);
      }
    });
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [fileUploaded, setFileUploaded] = useState('');
  const [canPost, setCanPost] = useState(true);

  const appendFile = () => {
    const formData = new FormData();
    formData.append('fileName', 'potentialClientFile');
    formData.append(`potencialClientFile`, fileUploaded);

    return formData;
  };

  const uploadAVImage = async () => {
    let fileToPost = appendFile(fileUploaded);

    if (canPost) {
      setCanPost(false);
      await potentialClientsService
        .createPCBatch(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            if (!response?.data?.fileErrors) {
              notify(`Archivo cargado con exito`, 'success');
            } else {
              notify(`El archivo contiene errores`, 'error');
            }
            handleImageModal();
            setFileUploaded('');
            setCanPost(true);
            getMemberships();
          } else {
            notify(`${response.message}`, 'error');
            setCanPost(true);
          }
        });
    }
  };

  return (
    <>
      <SendFileModal
        imageModal={showImageModal}
        handleImageModal={handleImageModal}
        setFileUploaded={setFileUploaded}
        fileUploaded={fileUploaded}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        uploadAVImage={uploadAVImage}
      />
      <Header />
      <div className="service-with-container container">
        <div className="buttons-container">
          <div className="d-flex flex-column align-items-start mb-4">
            <h1 className="title-component">Clientes Potenciales</h1>
            {converteRate && (
              <h5 className="subtitle-component">
                Porcentaje de Conversión: {converteRate}%
              </h5>
            )}
            {converteRate && (
              <h6 className="subtitle-component">
                Total de las Ordenes: {totalOrders}
              </h6>
            )}

          </div>
          <div
            className="row"
            style={{
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              {![
                salesRoles?.SALES_HUNTER,
                salesRoles?.SALES_COUNTER,
                salesRoles?.SALES_ADMIN_AUX,
                salesRoles?.SALES_KEY_ACCOUNTS,
              ].includes(authService?.getUserType()) &&
                ['Evento'].includes(membershipsDatatable.type) && (
                  <ActionButton
                    label={'Cargar Archivo'}
                    action={() => handleImageModal()}
                  />
                )}
              {![
                salesRoles?.SALES_HUNTER,
                salesRoles?.SALES_COUNTER,
                salesRoles?.SALES_ADMIN_AUX,
                salesRoles?.SALES_KEY_ACCOUNTS,
              ].includes(authService?.getUserType()) && (
                  <ActionButton
                    label={'Exportar'}
                    action={() => exportMemberships()}
                  />
                )}
            </div>
          </div>
        </div>
        <div className="breadcrumb-container">
          <div></div>
          <div
            className="exportables-buttons-container"
            style={{ width: '100%' }}
          >
            <FilterButton
              label={'Eventos'}
              type={matchTypeToLabel(membershipsDatatable?.type)}
              action={selectType}
            />
            <FilterButton
              label={'Particulares'}
              type={matchTypeToLabel(membershipsDatatable?.type)}
              action={selectType}
            />
            <FilterButton
              label={'Plan free'}
              type={matchTypeToLabel(membershipsDatatable?.type)}
              action={selectType}
            />
            <FilterButton
              label={'PAP'}
              type={matchTypeToLabel(membershipsDatatable?.type)}
              action={selectType}
            />
            <FilterButton
              label={'Incompletos'}
              type={matchTypeToLabel(membershipsDatatable?.type)}
              action={selectType}
            />
          </div>
          <div
            className="row"
            style={{
              width: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '10px',
              }}
            >
              <ActionButton
                label={'Limpiar Filtros'}
                action={() => {
                  setChannelOptions([]);
                  setCampaignActionOptions([]);
                  setAffiliatedOptions([]);
                  setServiceTypesOptions([]);
                  setServiceTypesOptions([]);
                }}
              />
            </div>
          </div>
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <div className="col-12 col-md-2" style={{ marginTop: '30px' }}>
                <SearchInput
                  placeholder={
                    'Nombre o Apellido, Teléfono, Cédula ,Referencia o Placa'
                  }
                  searchAction={getMemberships}
                  value={membershipsDatatable?.searchParam}
                  onChange={handleSearchChange}
                  width="50px"
                />
              </div>
              {![
                // salesRoles?.SALES_HUNTER,
                // salesRoles?.SALES_COUNTER,
                // salesRoles?.SALES_FARMER,
                salesRoles?.SALES_ADMIN_AUX,
              ].includes(authService?.getUserType()) ? (
                <>
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Desde'}
                    type={'date'}
                    name={'dateFrom'}
                    placeholder={''}
                    onChange={handleSinceDateChange}
                    value={dateFrom}
                    disabled={membershipsDatatable?.isLoading}
                  />
                  <FilterDatePicker
                    bootstrap={'col-12 col-md-2'}
                    label={'Hasta'}
                    type={'date'}
                    name={'dateTo'}
                    placeholder={''}
                    onChange={handleUntilDateChange}
                    value={dateTo}
                    disabled={membershipsDatatable?.isLoading}
                  />
                </>
              ) : null}
              <div
                style={{
                  marginTop: '24px',
                  marginLeft: 'auto',
                  width: '450px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  textAlign: 'center',
                  alignItems: 'center',
                }}
              >
                {![
                  salesRoles?.SALES_FARMER,
                  salesRoles?.SALES_HUNTER,
                  salesRoles?.SALES_COUNTER,
                  salesRoles?.SALES_ADMIN_AUX,
                  salesRoles?.SALES_KEY_ACCOUNTS,
                ].includes(authService?.getUserType()) && (
                    <SelectPerPage
                      label={'Registros por página'}
                      options={itemsPerpage}
                      value={membershipsDatatable?.limit}
                      onChange={selectitemsPerpage}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>

        <PotentialClientsTable
          header={potentialClientsTableHeader(
            membershipsDatatable?.type,
            channels,
            {
              channels: handleChannelOptions,
              campaign: handleCampaignActionOptions,
              affiliated: handleAffiliatedOptions,
              serviceTypes: handleServiceTypeOptions,
            },
            serviceTypes
          )}
          data={membershipsDatatable}
          handlePageChange={handlePageChange}
          redirectToEditOrder={redirectToEditOrder}
          redirectToOrderDetail={redirectToOrderDetail}
          renewMembership={renewMembership}
          tableRef={tableRef}
          dateFrom={dateFrom}
          dateTo={dateTo}
          updateClientFromGrid={updateClientFromGrid}
        />
      </div>
    </>
  );
};

